import { PropsWithChildren } from 'react';

import { useSearchParamState } from '@cast/utils';

import { TabsContext } from './TabsContext';

type TabsProviderProps<Value extends string = string> = PropsWithChildren<{
  initialTab?: Value;
  currentTab?: Value;
  setCurrentTab?: (tab: Value) => void;
  searchParamKey?: string;
}>;

export const TabsProvider = <Value extends string>({
  children,
  currentTab,
  setCurrentTab,
  initialTab,
  searchParamKey,
}: TabsProviderProps<Value>) => {
  const isControlled = currentTab !== undefined && !!setCurrentTab;
  const { state, setState } = useSearchParamState(searchParamKey, initialTab);
  const selectedTab = isControlled ? currentTab : state;
  const selectTab = isControlled ? setCurrentTab : setState;

  return (
    <TabsContext.Provider
      value={{
        currentTab: selectedTab,
        setCurrentTab: selectTab,
      }}
    >
      {children}
    </TabsContext.Provider>
  );
};
